import 'babel-polyfill';
import 'es6-promise/auto';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import { unregister } from './registerServiceWorker';
import LocaleProvider from 'antd/lib/locale-provider';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';

if (process.env.NODE_ENV === 'production') {
    import(/* webpackChunkName: "raven-js" */ 'raven-js').then(Raven => {
        window.Raven = Raven
        Raven.config('https://c5db0a582a1c4ec8b44025e7cad9eb7c@op-sentry.fapiaoer.cn/31').install()
    })
}

ReactDOM.render(<LocaleProvider locale={zh_CN}>
    <App/>
</LocaleProvider>, document.getElementById('root'));
unregister();
